import { createSlice } from "@reduxjs/toolkit";

import {
  getComplaintsThunk,
  createComplaintThunk,
  updateComplaintThunk,
  deleteComplaintThunk,
} from "state/action/complaints";

// Initial state
const initialState = {
  // Get Complaint inisial state
  getComplaints: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Complaint inisial state
  createComplaint: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Complaint inisial state
  updateComplaint: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Complaint inisial state
  deleteComplaint: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createComplaintInputBody: {
    unit: "",
    nature: "",
    type: "",
    date: "",
    description: "",
    title: "",
    category: "",
    priority: "",
    status: "",
    assign_staf: "",
  },
  // Complaint object value
  complaint_object_value: "",
};

export const complaintSlice = createSlice({
  name: "complaint",
  initialState,
  reducers: {
    setGetComplaintObjectValue: (state, action) => {
      return {
        ...state,
        complaint_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetComplaintObjectValue: (state, _) => {
      return {
        ...state,
        complaint_object_value: "",
      };
    },
    setCreateComplaintInputBody: (state, action) => {
      return {
        ...state,
        createComplaintInputBody: action.payload,
      };
    },
    setClearCreateComplaintInputBody: (state, _) => {
      return {
        ...state,
        createComplaintInputBody: {
          unit: "",
          nature: "",
          type: "",
          date: "",
          description: "",
          title: "",
          category: "",
          priority: "",
          status: "",
          assign_staf: "",
        },
      };
    },
    setClearGetComplaint: (state, _) => {
      return {
        ...state,
        getComplaints: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateComplaint: (state, _) => {
      return {
        ...state,
        createComplaint: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateComplaint: (state, _) => {
      return {
        ...state,
        updateComplaint: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteComplaint: (state, _) => {
      return {
        ...state,
        deleteComplaint: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllComplaintState: (state, _) => {
      return {
        ...state,
        // Get Complaint inisial state
        getComplaints: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Complaint inisial state
        createComplaint: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Complaint inisial state
        updateComplaint: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Complaint inisial state
        deleteComplaint: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Complaint object value
        complaint_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Complaint reducer
      .addCase(getComplaintsThunk.pending, (state, _) => {
        return {
          ...state,
          getComplaints: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getComplaintsThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getComplaints: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getComplaintsThunk.rejected, (state, action) => {
        return {
          ...state,
          getComplaints: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Complaint reducer
      .addCase(createComplaintThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createComplaintThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createComplaintThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Complaint reducer
      .addCase(updateComplaintThunk.pending, (state, _) => {
        return {
          ...state,
          updateComplaint: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateComplaintThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateComplaint: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateComplaintThunk.rejected, (state, action) => {
        return {
          ...state,
          updateComplaint: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const complaintAction = {
  ...complaintSlice.actions,
  getComplaintsThunk,
  createComplaintThunk,
  updateComplaintThunk,
  deleteComplaintThunk,
};

export function selectComplaintObjectValue(state) {
  return state?.complaints?.complaint_object_value;
}

export function selectComplaint(state) {
  return state?.complaints;
}

export default complaintSlice.reducer;
